module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2204563"
    }
  }, [_c('b', [_vm._v("CURRIED LENTIL SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2205063"
    }
  }, [_c('b', [_c('i', [_vm._v("Based on an Indian classic, this thick and hearty soup is bound to become a staple in your soup repertoire. Lentils, unlike other dried legumes, don’t require presoaking, so this can be prepared in less time than most other bean soups.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2207463"
    }
  }, [_c('b', [_vm._v("Prep: 30 minutes Cook: 1 hour")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2208063"
    }
  }, [_vm._v("2 tablespoons olive oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2208363"
    }
  }, [_vm._v("4 carrots, peeled and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2208663"
    }
  }, [_vm._v("2 large stalks celery, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2208963"
    }
  }, [_vm._v("1 large onion (12 ounces), finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2209263"
    }
  }, [_vm._v("1 medium Granny Smith apple, peeled, cored, "), _c('br'), _vm._v(" and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2210263"
    }
  }, [_vm._v("1 tablespoon grated, peeled fresh ginger")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2210563"
    }
  }, [_vm._v("1 large garlic clove, crushed with garlic press")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2210863"
    }
  }, [_vm._v("2 teaspoons curry powder")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2211163"
    }
  }, [_vm._v("¾ teaspoon ground cumin")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2212163"
    }
  }, [_vm._v("¾ teaspoon ground coriander")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2213063"
    }
  }, [_vm._v("1 package (16 ounces) lentils, rinsed and "), _c('br'), _vm._v(" picked through")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2213663"
    }
  }, [_vm._v("5 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2214063"
    }
  }, [_vm._v("2 cans (14½ ounces each) vegetable or chicken broth "), _c('br'), _vm._v(" or 3½ cups Vegetable Broth or Chicken "), _c('br'), _vm._v(" Broth")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2216963"
    }
  }, [_vm._v("¼ cup chopped fresh cilantro")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2217863"
    }
  }, [_vm._v("½ teaspoon salt "), _c('br'), _vm._v(" plain low-fat yogurt")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2219363"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart Dutch oven, heat oil over medium-high heat. Add carrots, celery, onion, and apple; cook, stirring occasionally, until lightly browned, 10 to 15 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2221263"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Add ginger, garlic, curry powder, cumin, and coriander; cook, stirring, 1 minute.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2222263"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Add lentils, water, and broth; heat to boiling over high heat. Reduce heat; cover and simmer, stirring occasionally, until lentils are tender, 45 to 55 minutes. Stir in cilantro and salt. To serve, top soup with dollops of yogurt. Makes about 10 cups or 5 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2224663"
    }
  }, [_vm._v("Each serving without yogurt: About 434 calories, 27g protein, 69g carbohydrate, 7g total fat (1g saturated), 0mg cholesterol, 966mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2901c662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c65_r1.vue
// module id = 261
// module chunks = 0